export const SET_USER_ID = "drive::set::userId";
export const SET_USER_PASSWORD = "drive::password::set";
export const SET_CONTENT = "drive::content::set";
export const UPLOADS_START = 'drive::uploads::start';
export const UPLOADS_COMPLETE = "drive::upload::complete";
export const UPDATE_UPLOAD_STEP = "drive::upload::state::update";
export const FILE_DELETE = "drive::file::delete";
